import React, {useState, useEffect} from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { parseUrl } from "query-string";
import get from "lodash/get";
import assetify from '@quintype/framework/assetify'
import successLogo from "../../../../../assets/images/nl-images/nl-subscription-2.jpg"
import { subscriptionMerchandise } from './MERCH'
import './confirmation.m.css'
import Loader from '../../../atoms/loader'
import { createShopifyOrder } from '../../../../../server/handlers/cartoon-mango';

export const Confirmation = (props) => {

    const [planName, setPlanName] = useState("")
    const [showMerchForm, setShowMerchForm] = useState(false)
    
    const member = useSelector(state => {
        return get(state, ["member"], null);
    });

    const currentPath = useSelector(state => get(state, ["qt", "currentPath"], ""));
	const params = parseUrl(currentPath);
    const status = params.query.status
    const gameChanger = params.query.gamechanger
    const disruptor = params.query.disruptor

    useEffect(()=>{
        if(gameChanger){
            setShowMerchForm(true)
            setPlanName("gameChanger")
        }
        else if(disruptor){
            setShowMerchForm(true)
            setPlanName("disruptor")
        }
    }, [])
    
    return(
        <div styleName='wrapper' className='container'>
            <img src={assetify(successLogo)}/>
            <h2>You’re a star! Thank you so much for paying to keep news free and supporting our journalism.</h2>
            <p/>
            { showMerchForm &&
                <MerchForm planName={planName} member={member} showMerchForm={showMerchForm} setShowMerchForm={setShowMerchForm}/>
            }
        </div>
    )
}

const MerchForm = ({planName, member, showMerchForm, setShowMerchForm}) => {

    const [data, setData] = useState({
        loading: false,
        success: false,
        error: "",
        address: "",
        phone: "",
        city: "",
        state: "",
        pincode: ""
    });

    const [error, setError] = useState(null);
    const { loading, address, phone, city, state, pincode } = data;

    const handleChange = e => {
        const { name, value } = e.target;
        setData(prevState => ({ ...prevState, [name]: value }));
    };

    const handleSubmit = async e =>{
      
        try{
            e.preventDefault()
            setData({loading:true})

            const productsToOrder = subscriptionMerchandise[planName];
            console.log(productsToOrder)
            
       
            const lineItems = productsToOrder && productsToOrder.length && productsToOrder.map((product) => ({
                variant_id: product.variantId,
                quantity: 1,
            }));

            const userEmail = member.email;
    
            let userName = {};
            if (member['last-name'] && member['last-name'].length) {
                userName = {
                    first_name: member['first-name'] || member.name,
                    last_name: member['last-name'],
                };
            } else {
                userName = {
                    first_name: '',
                    last_name: member['first-name'] || member.name,
                };
            }
            const userAddress = {
                address1: address,
                phone: phone,
                city,
                province: state,
                zip: pincode,
                country: 'India',
            };
            const payload = {
                order: {
                    email: userEmail,
                    line_items: [...lineItems],
                    customer: {
                        first_name: member['first-name'] || member.name,
                        last_name: member['last-name'],
                        email: userEmail,
                    },
                    billing_address: {
                        ...userName,
                        ...userAddress,
                    },
                    shipping_address: {
                        ...userName,
                        ...userAddress,
                    },
                },
            };

            createShopifyOrder(payload);
            setShowMerchForm(false)
        }catch(e){
            console.log(e)
            setError("Something went wrong, please contact subscriptions@newslaundry.com")
        } finally{
            setData({loading:false})
        }
    }

    return(
        <div styleName="merch-form-wrapper">
            <h5>Shipping address</h5>
            <small>The address you would like the Newslaundry merch to be shipped to (if you're based overseas, please share an Indian address)</small>

            <form onSubmit={handleSubmit}>
                <div styleName="form-group">
                    <label htmlFor="address" styleName="text">
                        Address
                    </label>
                    <input
                        styleName="input-text"
                        required
                        value={address}
                        id="address"
                        type="text"
                        placeholder="Street address"
                        name="address"
                        onChange={handleChange}
                    ></input>
                </div>

                <div styleName="flex-wrap">
                    <div styleName="form-group">
                    <label htmlFor="city" styleName="text">
                        City
                    </label>
                    <input
                        styleName="input-text"
                        required
                        value={city}
                        id="city"
                        type="text"
                        placeholder="City"
                        name="city"
                        onChange={handleChange}
                    ></input>
                </div>

                <div styleName="form-group">
                    <label htmlFor="state" styleName="text">
                        State
                    </label>
                    <input
                        styleName="input-text"
                        required
                        value={state}
                        id="state"
                        type="text"
                        placeholder="State"
                        name="state"
                        onChange={handleChange}
                    ></input>
                </div>

                <div styleName="form-group">
                    <label htmlFor="pincode" styleName="text">
                        Pincode
                    </label>
                    <input
                        styleName="input-text"
                        required
                        value={pincode}
                        id="pincode"
                        type="text"
                        placeholder="Pincode"
                        name="pincode"
                        onChange={handleChange}
                    ></input>
                    </div>
                </div>

                <div styleName="form-group">
                    <label htmlFor="phone" styleName="text">
                        Phone Number
                    </label>
                    <input
                        styleName="input-text"
                        required
                        value={phone}
                        id="phone"
                        type="text"
                        placeholder="Phone"
                        name="phone"
                        onChange={handleChange}
                    ></input>
                </div>
                <small styleName="error-message">{error}</small><br/>
                <button type='submit'>
                    {!loading?
                        "Submit"
                    :
                        <Loader/>
                    }
                </button>
            </form>
        </div>
    )
}